<script lang="ts" setup>
import { MinusIcon, PlusIcon } from '@fond-of/satch-icons'
</script>

<template>
  <div
    class="group mb-5 flex w-full cursor-pointer flex-wrap items-center text-base"
  >
    <span
      class="flex-center size-5.5 mr-2.5 flex flex-wrap rounded-full border-2 border-black p-px"
    >
      <PlusIcon
        class="inline-block size-4 group-data-[state=open]/item:hidden"
      />
      <MinusIcon
        class="inline-block size-4 group-data-[state=closed]/item:hidden"
      />
    </span>

    <span class="transition-all duration-200 ease-linear group-hover:ml-1">
      <slot />
    </span>
  </div>
</template>
